"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _chess = require("chess.js");
var _useSound9 = _interopRequireDefault(require("use-sound"));
var _utils = require("./utils");
var _excluded = ["children", "position", "lastMoveFen", "handleNewFen"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
// const moveSound = new Howl({ src: ["../../assests/move-self.mp3"], volume: 1.0 });

function didCaptureOccur(lastFen, currentFen) {
  var getPieceCount = function getPieceCount(fen) {
    var _fen$split;
    return fen === null || fen === void 0 || (_fen$split = fen.split(" ")) === null || _fen$split === void 0 || (_fen$split = _fen$split[0]) === null || _fen$split === void 0 || (_fen$split = _fen$split.replace(/[\d/]/g, "")) === null || _fen$split === void 0 ? void 0 : _fen$split.length;
  };
  var lastCount = getPieceCount(lastFen);
  var currentCount = getPieceCount(currentFen);
  return currentCount < lastCount;
}
function findMoveFromFens(lastMoveFen, currentMoveFen) {
  var chessLast = new _chess.Chess(lastMoveFen);
  var chessCurrent = new _chess.Chess(currentMoveFen);

  // Generate all legal moves from the last position
  var moves = chessLast.moves({
    verbose: true
  });
  for (var i = 0; i < moves.length; i++) {
    chessLast.move(moves[i]);
    if (chessLast.fen() === currentMoveFen) {
      // If the FENs match, we found our move
      return {
        from: moves[i].from,
        to: moves[i].to
      };
    }
    chessLast.undo(); // Undo the move to try the next one
  }
  return null; // If no move leads to the current FEN, return null
}
var ChessGame = function ChessGame(_ref) {
  var children = _ref.children,
    _ref$position = _ref.position,
    position = _ref$position === void 0 ? "start" : _ref$position,
    lastMoveFen = _ref.lastMoveFen,
    handleNewFen = _ref.handleNewFen,
    rest = _objectWithoutProperties(_ref, _excluded);
  // const moveAudio = new Audio(moveSound);
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    kingInCheckSquare = _useState2[0],
    setKingInCheckSquare = _useState2[1];
  var _useSound = (0, _useSound9["default"])("https://images.chesscomfiles.com/chess-themes/sounds/_MP3_/default/move-self.mp3"),
    _useSound2 = _slicedToArray(_useSound, 1),
    moveSound = _useSound2[0];
  var _useSound3 = (0, _useSound9["default"])("https://images.chesscomfiles.com/chess-themes/sounds/_MP3_/default/capture.mp3"),
    _useSound4 = _slicedToArray(_useSound3, 1),
    captureSound = _useSound4[0];
  var _useSound5 = (0, _useSound9["default"])("https://images.chesscomfiles.com/chess-themes/sounds/_MP3_/default/castle.mp3"),
    _useSound6 = _slicedToArray(_useSound5, 1),
    castlingSound = _useSound6[0];
  var _useSound7 = (0, _useSound9["default"])("https://images.chesscomfiles.com/chess-themes/sounds/_MP3_/default/move-check.mp3"),
    _useSound8 = _slicedToArray(_useSound7, 1),
    checkSound = _useSound8[0];
  var chess = (0, _react.useMemo)(function () {
    return new _chess.Chess(position === "start" ? "rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1" : position);
  }, [position, rest === null || rest === void 0 ? void 0 : rest.resetChessboard]);
  var _useState3 = (0, _react.useState)(chess === null || chess === void 0 ? void 0 : chess.fen()),
    _useState4 = _slicedToArray(_useState3, 2),
    fen = _useState4[0],
    setFen = _useState4[1];
  var _useState5 = (0, _react.useState)(null),
    _useState6 = _slicedToArray(_useState5, 2),
    lastMove = _useState6[0],
    setLastMove = _useState6[1];
  var _useState7 = (0, _react.useState)(null),
    _useState8 = _slicedToArray(_useState7, 2),
    makeMoveFen = _useState8[0],
    setMakeMoveFen = _useState8[1];
  var _useState9 = (0, _react.useState)(""),
    _useState10 = _slicedToArray(_useState9, 2),
    over = _useState10[0],
    setOver = _useState10[1];
  var _useState11 = (0, _react.useState)(false),
    _useState12 = _slicedToArray(_useState11, 2),
    isPromotionModalVisible = _useState12[0],
    setIsPromotionModalVisible = _useState12[1];
  var _useState13 = (0, _react.useState)(null),
    _useState14 = _slicedToArray(_useState13, 2),
    promotionData = _useState14[0],
    setPromotionData = _useState14[1]; // To store the source and target squares

  var _useState15 = (0, _react.useState)(null),
    _useState16 = _slicedToArray(_useState15, 2),
    selectedSquare = _useState16[0],
    setSelectedSquare = _useState16[1];
  var _useState17 = (0, _react.useState)([]),
    _useState18 = _slicedToArray(_useState17, 2),
    possibleMoves = _useState18[0],
    setPossibleMoves = _useState18[1];
  var onSquareSelected = (0, _react.useCallback)(function (square) {
    setSelectedSquare(square);
    var moves = chess.moves({
      square: square,
      verbose: true
    }).map(function (move) {
      return move.to;
    });
    setPossibleMoves(moves);
  }, [chess]);
  console.log("abcde", makeMoveFen);
  (0, _react.useEffect)(function () {
    var tempNewPosition = position === "start" ? "rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1" : position;
    console.log('abcde tempNewPosition', tempNewPosition, 'lalala', chess === null || chess === void 0 ? void 0 : chess.fen(), makeMoveFen);
    if (tempNewPosition !== makeMoveFen) {
      if (lastMoveFen) {
        // chess?.load?.(lastMoveFen); 
        // console.log('abcde loaded lastMoveFen', lastMoveFen);
        var timeoutId = setTimeout(function () {
          var _chess$inCheck;
          chess === null || chess === void 0 || chess.load(position); // After delay, set the board to positionFen
          setFen(tempNewPosition);
          var moveDetails = findMoveFromFens === null || findMoveFromFens === void 0 ? void 0 : findMoveFromFens(lastMoveFen, position);
          setLastMove(moveDetails);

          // Check if a capture occurred and play the capture sound
          if (moveDetails && didCaptureOccur(lastMoveFen, position)) {
            captureSound();
          } else if (chess !== null && chess !== void 0 && (_chess$inCheck = chess.inCheck) !== null && _chess$inCheck !== void 0 && _chess$inCheck.call(chess)) {
            checkSound(); // Play check sound
          } else {
            moveSound();
          }
          // setLastMove(findMoveFromFens(lastMoveFen, position));
        }, 10);
        setMakeMoveFen('');
        return function () {
          return clearTimeout(timeoutId);
        };
        // setLastMove(findMoveFromFens(lastMoveFen, position));
      } else {
        // setLastMove({ from: "", to: "" });
        console.log('abcde no lastMoveFen', tempNewPosition);
        chess === null || chess === void 0 || chess.load(tempNewPosition);
        setFen(tempNewPosition);
      }
      setMakeMoveFen('');
    }
  }, [position, lastMoveFen, rest === null || rest === void 0 ? void 0 : rest.resetChessboard]);
  function onDrop(sourceSquare, targetSquare, promotedPiece) {
    console.log("b....>>>> promoted Piece", promotedPiece);
    try {
      var _promotedPiece$, _rest$onPieceDropExte;
      var moveData = {
        from: sourceSquare,
        to: targetSquare,
        promotion: promotedPiece === null || promotedPiece === void 0 || (_promotedPiece$ = promotedPiece[1]) === null || _promotedPiece$ === void 0 ? void 0 : _promotedPiece$.toLowerCase()
      };
      var allMoves = chess.moves({
        verbose: true
      });
      var isValidMove = allMoves.some(function (move) {
        return move.from === sourceSquare && move.to === targetSquare;
      });
      if (!isValidMove) return false;
      var shallStop = rest === null || rest === void 0 || (_rest$onPieceDropExte = rest.onPieceDropExtension) === null || _rest$onPieceDropExte === void 0 ? void 0 : _rest$onPieceDropExte.call(rest, moveData.from, moveData.to, moveData.promotion);
      if (shallStop) return false;
      var move = makeAMove(moveData);
      if (!move) return false;
      if (move !== null) setLastMove({
        from: sourceSquare,
        to: targetSquare
      });
      return move !== null;
    } catch (e) {
      console.error(e); // Log the error
      return false;
    }
  }

  // function onDrop(sourceSquare, targetSquare, promotedPiece) {
  //   try {
  //     const moveData = {
  //       from: sourceSquare,
  //       to: targetSquare,
  //       color: chess?.turn(),
  //       promotion: promotedPiece?.[1]?.toLowerCase() || "q",
  //     };

  //     // const moveData = {
  //     //   from: sourceSquare,
  //     //   to: targetSquare,
  //     //   promotion: promotedPiece?.[1]?.toLowerCase() || "q",
  //     // };

  //     // Check if the move is valid but don't make the move yet
  //     const isValidMove = chess
  //       ?.moves({ verbose: true })
  //       .some(
  //         (move) =>
  //           move.from === sourceSquare &&
  //           move.to === targetSquare &&
  //           (!promotedPiece ||
  //             move.promotion === promotedPiece[1].toLowerCase())
  //       );

  //     console.log(isValidMove, "isValidMove");
  //     if (!isValidMove) return false;

  //     // Check if the move should be stopped
  //     const shallStop = rest?.onPieceDropExtension?.(
  //       sourceSquare,
  //       targetSquare
  //     );
  //     console.log(shallStop, "shallStop");
  //     if (shallStop) {
  //       return false;
  //     }

  //     const move = makeAMove(moveData);
  //     if (!move) return false;

  //     // const shallStop = rest?.onPieceDropExtension?.(
  //     //   sourceSquare,
  //     //   targetSquare
  //     // );
  //     // console.log(shallStop, "shallStop");
  //     // if (shallStop) {
  //     //   return false;
  //     // }

  //     if (move !== null) {
  //       setLastMove({ from: sourceSquare, to: targetSquare });
  //     }
  //     return move !== null;
  //   } catch (e) {
  //     return false;
  //     //ignore
  //   }
  // }

  var makeAMove = (0, _react.useCallback)(function (move) {
    try {
      var _chess$inCheck2;
      var lastFen = chess.fen();
      var result = chess === null || chess === void 0 ? void 0 : chess.move(move);
      var newFen = chess.fen();
      if (result) {
        // Constructing move data
        var moveData = {
          from: result.from,
          to: result.to,
          piece: result.piece,
          san: result.san,
          // Standard Algebraic Notation of the move
          newFen: newFen,
          // New FEN string after the move
          lastFen: lastFen
        };

        // Calling handleNewFen with the new FEN string and move data
        handleNewFen === null || handleNewFen === void 0 || handleNewFen(moveData);
      }
      setFen(newFen);
      setMakeMoveFen(newFen);
      if (result && result.captured) {
        captureSound();
      } else if (chess !== null && chess !== void 0 && (_chess$inCheck2 = chess.inCheck) !== null && _chess$inCheck2 !== void 0 && _chess$inCheck2.call(chess)) {
        checkSound(); // Play check sound
      } else {
        moveSound();
      }
      if (chess !== null && chess !== void 0 && chess.isGameOver()) {
        if (chess !== null && chess !== void 0 && chess.isCheckmate()) {
          setOver("Checkmate! ".concat((chess === null || chess === void 0 ? void 0 : chess.turn()) === "w" ? "black" : "white", " wins!"));
        } else if (chess !== null && chess !== void 0 && chess.isDraw()) {
          setOver("Draw");
        } else {
          setOver("Game over");
        }
      }
      return result;
    } catch (e) {
      return null;
    }
  }, [chess, moveSound, captureSound, castlingSound, checkSound, handleNewFen]);
  (0, _react.useEffect)(function () {
    var _chess$inCheck3;
    console.log('abcde change in fen', fen, chess === null || chess === void 0 ? void 0 : chess.fen());
    if (chess !== null && chess !== void 0 && (_chess$inCheck3 = chess.inCheck) !== null && _chess$inCheck3 !== void 0 && _chess$inCheck3.call(chess)) {
      var kingPosition = findKingPosition(chess === null || chess === void 0 ? void 0 : chess.fen(), chess === null || chess === void 0 ? void 0 : chess.turn());
      console.log("abcde inside set king in check useeffect", fen, kingPosition);
      setKingInCheckSquare(kingPosition);
    } else {
      console.log("abcde inside set king in check useeffect 2", fen);
      setKingInCheckSquare(null);
    }
  }, [fen]);
  function findKingPosition(fen, turn) {
    var _fen$split2;
    var rows = fen === null || fen === void 0 || (_fen$split2 = fen.split(" ")) === null || _fen$split2 === void 0 || (_fen$split2 = _fen$split2[0]) === null || _fen$split2 === void 0 ? void 0 : _fen$split2.split("/");
    var king = turn === "w" ? "K" : "k";
    for (var row = 0; row < (rows === null || rows === void 0 ? void 0 : rows.length); row++) {
      var col = 0;
      var _iterator = _createForOfIteratorHelper(rows[row]),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _char = _step.value;
          if (_char === king) {
            return String.fromCharCode(97 + col) + (8 - row);
          } else if (isNaN(_char)) {
            col++;
          } else {
            col += parseInt(_char, 10);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, children(_objectSpread({
    position: fen,
    onMove: onDrop,
    lastMove: lastMove,
    selectedSquare: selectedSquare,
    possibleMoves: possibleMoves,
    onSquareSelected: onSquareSelected,
    chess: chess,
    kingInCheckSquare: kingInCheckSquare,
    setSelectedSquare: setSelectedSquare,
    setPossibleMoves: setPossibleMoves
  }, rest)));
};
var _default = exports["default"] = ChessGame;